'use client';

import cn from 'classnames';
import React, {
  HTMLAttributes,
  PropsWithChildren,
  useEffect,
  useRef,
  useState,
} from 'react';

function FadeInSection(
  props: PropsWithChildren<HTMLAttributes<HTMLDivElement> & { delay?: number }>,
) {
  const { className, children, delay = 0 } = props;
  const [isVisible, setVisible] = useState(false);
  const domRef = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            setVisible(true);
          }, delay);
        }
      });
    });
    observer.observe(domRef.current);
    return () => {
      observer.disconnect();
    };
  }, [delay]);

  return (
    <div
      ref={domRef}
      className={cn(
        className,
        '!ease-layout-enter',
        'fade-in-section',
        isVisible ? 'is-visible' : '',
      )}
    >
      {children}
    </div>
  );
}

export default FadeInSection;
